(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    // Detect simple dropdowns and add data attribute to header
  class SimpleDropdownDetector extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.header');
      this.menuItems = document.querySelectorAll('.menu-list__list-item');

      // Monitor aria-expanded changes on all menu links
      this.menuItems.forEach(menuItem => {
        const menuLink = menuItem.querySelector('.menu-list__link[aria-controls]');
        if (menuLink) {
          // Use MutationObserver to detect aria-expanded changes
          const observer = new MutationObserver(() => {
            this.checkSimpleDropdown(menuItem, menuLink);
          });

          observer.observe(menuLink, {
            attributes: true,
            attributeFilter: ['aria-expanded']
          });

          // Check initial state
          this.checkSimpleDropdown(menuItem, menuLink);
        }
      });
    }

    checkSimpleDropdown(menuItem, menuLink) {
      const isExpanded = menuLink.getAttribute('aria-expanded') === 'true';
      const hasParentLinks = menuItem.querySelector('.mega-menu__link--parent');

      if (isExpanded && !hasParentLinks) {
        // Simple dropdown is open
        this.header?.setAttribute('data-simple-dropdown-open', 'true');
      } else if (!isExpanded) {
        // Check if any other simple dropdown is open
        const anySimpleDropdownOpen = Array.from(this.menuItems).some(item => {
          const link = item.querySelector('.menu-list__link[aria-controls]');
          const expanded = link?.getAttribute('aria-expanded') === 'true';
          const hasParent = item.querySelector('.mega-menu__link--parent');
          return expanded && !hasParent;
        });

        if (!anySimpleDropdownOpen) {
          this.header?.removeAttribute('data-simple-dropdown-open');
        }
      }
    }
  }

  customElements.define('simple-dropdown-detector', SimpleDropdownDetector);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-group"] && !Shopify.designMode) return;
  try {
    class ContactGroupToggle extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector('[data-contact-group-header]');
      if (!header) return;

      const buttons = header.querySelectorAll('button, a[role="button"]');
      const calendlyWrapper = this.querySelector('.contact-form--wrapper_calendly');
      const contactFormWrapper = this.querySelector('.contact-form--wrapper_contact-form');

      if (buttons.length < 2 || !calendlyWrapper || !contactFormWrapper) return;

      const [calendlyBtn, contactFormBtn] = buttons;

      // Add click handlers
      calendlyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.showCalendly(calendlyBtn, contactFormBtn, calendlyWrapper, contactFormWrapper);
      });

      contactFormBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.showContactForm(calendlyBtn, contactFormBtn, calendlyWrapper, contactFormWrapper);
      });

      // Check for contact_posted URL parameter
      this.checkContactPosted(calendlyBtn, contactFormBtn, calendlyWrapper, contactFormWrapper);
    }

    showCalendly(calendlyBtn, contactFormBtn, calendlyWrapper, contactFormWrapper) {
      // Swap classes: calendly becomes active (secondary), contact form becomes inactive (primary)
      calendlyBtn.classList.remove('button');
      calendlyBtn.classList.add('button-secondary');
      contactFormBtn.classList.remove('button-secondary');
      contactFormBtn.classList.add('button');
      // Toggle form visibility
      calendlyWrapper.classList.remove('hidden');
      contactFormWrapper.classList.add('hidden');
    }

    showContactForm(calendlyBtn, contactFormBtn, calendlyWrapper, contactFormWrapper) {
      // Swap classes: contact form becomes active (secondary), calendly becomes inactive (primary)
      contactFormBtn.classList.remove('button');
      contactFormBtn.classList.add('button-secondary');
      calendlyBtn.classList.remove('button-secondary');
      calendlyBtn.classList.add('button');
      // Toggle form visibility
      contactFormWrapper.classList.remove('hidden');
      calendlyWrapper.classList.add('hidden');
    }

    async checkContactPosted(calendlyBtn, contactFormBtn, calendlyWrapper, contactFormWrapper) {
      const urlParams = new URLSearchParams(window.location.search);
      const contactPosted = urlParams.get('contact_posted');

      if (contactPosted === 'true') {
        // Auto-activate the contact form tab
        this.showContactForm(calendlyBtn, contactFormBtn, calendlyWrapper, contactFormWrapper);

        // Show success message if not already rendered by Liquid
        const contactForm = contactFormWrapper.querySelector('.contact-form');
        let successMessage = contactForm?.querySelector('.contact-form__success');

        if (!successMessage) {
          // Create success message element
          successMessage = document.createElement('div');
          successMessage.className = 'contact-form__success';
          successMessage.setAttribute('tabindex', '-1');

          // Fetch and add checkmark icon
          try {
            const iconResponse = await fetch(window.Shopify.routes.root + 'cdn/shop/t/2/assets/icon-tick-circle.svg');
            const iconSvg = await iconResponse.text();
            const iconWrapper = document.createElement('div');
            iconWrapper.innerHTML = iconSvg;
            successMessage.appendChild(iconWrapper.firstChild);
          } catch (error) {
            console.error('Failed to load checkmark icon:', error);
          }

          // Add success text
          const text = document.createTextNode("Thanks for contacting us. We'll get back to you as soon as possible.");
          successMessage.appendChild(text);

          // Find submit button and insert success message before it
          const form = contactForm?.querySelector('form');
          const submitButton = form?.querySelector('button[type="submit"]');

          if (form && submitButton) {
            // Insert success message before the submit button
            submitButton.parentNode.insertBefore(successMessage, submitButton);
            // Hide the submit button
            submitButton.style.display = 'none';
          }
        } else {
          // If success message already exists (rendered by Liquid), hide the submit button
          const form = contactForm?.querySelector('form');
          const submitButton = form?.querySelector('button[type="submit"]');
          if (submitButton) {
            submitButton.style.display = 'none';
          }
        }

        // Scroll to success message
        setTimeout(() => {
          successMessage?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          successMessage?.focus();
        }, 300);

        // Clean up URL (remove query parameter)
        const url = new URL(window.location);
        url.searchParams.delete('contact_posted');
        window.history.replaceState({}, '', url);
      }
    }
  }

  customElements.define('contact-group-toggle', ContactGroupToggle);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    // Handle newsletter success state from URL parameter
  (function() {
    const urlParams = new URLSearchParams(window.location.search);
    const customerPosted = urlParams.get('customer_posted');

    if (customerPosted === 'true') {
      // Find all email signup blocks
      const emailSignupBlocks = document.querySelectorAll('.email-signup-block');

      emailSignupBlocks.forEach(block => {
        // Add success class
        block.classList.add('email-signup-block--success');

        // Check if success message already exists
        let successMessage = block.querySelector('.email-signup__message');

        if (!successMessage) {
          // Create success message
          successMessage = document.createElement('div');
          successMessage.className = 'email-signup__message';
          successMessage.setAttribute('tabindex', '-1');

          // Add checkmark icon
          const iconWrapper = document.createElement('span');
          iconWrapper.className = 'svg-wrapper icon-success';
          iconWrapper.innerHTML = `<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
            <circle cx="10" cy="10" r="9" fill="none" stroke="currentColor" stroke-width="2"></circle>
            <path d="M6 10l3 3 5-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>`;
          successMessage.appendChild(iconWrapper);

          // Add success text
          const textElement = document.createElement('p');
          textElement.className = 'email-signup__message-text';
          textElement.textContent = "Thanks for subscribing!";
          successMessage.appendChild(textElement);

          // Find the form and append success message
          const form = block.querySelector('.email-signup__form');
          if (form) {
            form.appendChild(successMessage);
          }
        }

        // Scroll to success message
        setTimeout(() => {
          successMessage?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
      });

      // Clean up URL
      const url = new URL(window.location);
      url.searchParams.delete('customer_posted');
      window.history.replaceState({}, '', url);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
